import type { Color, IGraphSizes, IPosition } from '../helpers';
import { getColorCode, getCoordinates } from '../helpers';

interface IStepLabelProps {
    color: Color;
    graphSizes: IGraphSizes;
    label: string;
    onMouseOut: () => void;
    onMouseOver: () => void;
    position: IPosition;
}

export function StepLabel(props: IStepLabelProps) {
    const { color, position, label, graphSizes, onMouseOver, onMouseOut } = props;
    const coordinates = getCoordinates(position, graphSizes);

    return (
        <foreignObject
            color={getColorCode(color)}
            height={graphSizes.nodeHeight}
            onMouseOut={onMouseOut}
            onMouseOver={onMouseOver}
            width={graphSizes.nodeWidth}
            x={coordinates.x}
            y={coordinates.y}
        >
            <div
                style={{
                    display: 'table-cell',
                    height: `${graphSizes.nodeHeight}px`,
                    verticalAlign: 'middle',
                    width: `${graphSizes.nodeWidth}px`,
                }}
            >
                <p
                    style={{
                        fontSize: `${graphSizes.nodeHeight / 5}px`,
                        lineHeight: `${graphSizes.nodeHeight / 4}px`,
                        textAlign: 'center',
                    }}
                >
                    {label}
                </p>
            </div>
        </foreignObject>
    );
}
